import axios from 'axios';
import authHeader from "@/service/auth-header";

class StockHistoryService {

    async getStockHistory(exchange, code) {
        console.log("[" + name + "][getStockHistory] exchange = ", exchange);
        console.log("[" + name + "][getStockHistory] code = ", code);
        return await axios.get(`/api/applications/si/stockhistory/exchange/${exchange}/${code}`, {headers: authHeader()})
    }

}

export default new StockHistoryService();
